// removed by extract-text-webpack-plugin
module.exports = {"pagination-block":"pagination-block","pagination":"pagination","disabled":"disabled","current":"current"};


//////////////////
// WEBPACK FOOTER
// ./resources/css/scss/4-objects/_pagination.scss
// module id = 16
// module chunks = 0